export default "__VITE_ASSET__CGEHLzTb__"